import { useTranslation } from "react-i18next";
import { FCC } from "types";

import { HintTooltip } from "@/components/Interface/HintTooltip/HintTooltip";
import { SimCardDetailNetworkResetNotAllowedReasonsItem } from "@/services/model";

interface Props {
  reasons?: SimCardDetailNetworkResetNotAllowedReasonsItem[];
  leftOnMobile?: boolean;
  dataTestId?: string;
}

export const NetworkResetDisabledTooltip: FCC<Props> = ({
  reasons = [],
  leftOnMobile,
  children,
}) => {
  const { t } = useTranslation(undefined, {
    keyPrefix:
      "cockpit.managementTile.details.sections.details.networkReset.reasons",
  });

  // Reasons from api
  const {
    SIM_LOCKED,
    SIM_CANCELLED,
    SIM_TERMINATED,
    SIM_INACTIVE,
    OPEN_ONP,
    OPEN_ORDER,
    OPEN_SPEED_AND_LOCK,
    OPEN_NETWORK_RESET,
    OPEN_ESIM_RESET,
    OPEN_ESIM_CHANGE,
  } = SimCardDetailNetworkResetNotAllowedReasonsItem;

  const translatedReasons = reasons.reduce<string[]>((acc, reason) => {
    switch (reason) {
      case SIM_LOCKED:
        acc.push(t("simLocked"));
        break;
      case SIM_CANCELLED:
        acc.push(t("simCancelled"));
        break;
      case SIM_TERMINATED:
        acc.push(t("simTerminated"));
        break;
      case SIM_INACTIVE:
        acc.push(t("simInactive"));
        break;
      case OPEN_ONP:
        acc.push(t("openONP"));
        break;
      case OPEN_ORDER:
        acc.push(t("openOrder"));
        break;
      case OPEN_SPEED_AND_LOCK:
        acc.push(t("openSpeedAndLock"));
        break;
      case OPEN_NETWORK_RESET:
        acc.push(t("openNetworkReset"));
        break;
      case OPEN_ESIM_RESET:
        acc.push(t("openEsimReset"));
        break;
      case OPEN_ESIM_CHANGE:
        acc.push(t("openEsimChange"));
        break;
    }

    return acc;
  }, []);

  return (
    <HintTooltip
      dataTestid="network-reset-disabled-tooltip"
      align={leftOnMobile ? "right" : "left"}
      content={
        <>
          <span className="mb-1 block font-semibold">
            {t("portal:common.tooltip.actionNotPossible.title")}
          </span>
          <span className="block">
            {t("portal:common.tooltip.actionNotPossible.text", {
              count: translatedReasons.length,
            })}
          </span>
          {!!translatedReasons.length && (
            <ul className="mt-1 list-outside list-disc pl-4">
              {translatedReasons.map((reason: string) => (
                <li key={reason}>{reason}</li>
              ))}
            </ul>
          )}
        </>
      }
    >
      {children}
    </HintTooltip>
  );
};
